import { api, providesList } from ".";
import qs from "query-string";

const url = "/user-farm";

const userFarmApi = api.injectEndpoints({
	endpoints: (build) => ({
		getUserFarm: build.query<UserFarm[], Record<string, any> | undefined>({
			query: (query) => {
				if (query) {
					return `${url}?${qs.stringify(query)}`;
				}
				return url;
			},
			providesTags: (result) => providesList(result, "user-farm"),
		}),
		createUserFarm: build.mutation<void, Record<string, any>>({
			query: (data) => {
				return {
					url,
					method: "POST",
					body: data,
				};
			},
			invalidatesTags: (result, error, { id }) => {
				return error ? [] : [{ type: "user-farm", id }];
			},
		}),
		importUserFarms: build.mutation<{ success: number; failed: string[] }, ImportUserFarmRow[]>({
			query: (body) => ({
				url: `${url}/import`,
				method: "POST",
				body,
			}),
			invalidatesTags: (result, error) => (error ? [] : ["user-farm"]),
		}),
		deleteUserFarm: build.mutation<void, number | undefined>({
			query: (id) => {
				return {
					url: `${url}/${id}`,
					method: "DELETE",
				};
			},
			// invalidatesTags: (result, error, id) => {
			// 	return error ? [] : [{ type: "user-farm", id }];
			// },
		}),
	}),
});
export interface ImportUserFarmRow {
	username: string;
	farm_code: string;
	start_date: string;
	end_date: string;
	status: string;
}

export const { useGetUserFarmQuery, useLazyGetUserFarmQuery, useCreateUserFarmMutation, useImportUserFarmsMutation, useDeleteUserFarmMutation } = userFarmApi;
